import z from "zod"

export const GetReveniReturnResponseDataSchema = z.object({
  count: z.number(),
  results: z.array(
    z.object({
      id: z.string(),
      external_id: z.string().nullable(),
      type: z.string(),
      refund_method: z.string().nullish(),
      status: z.string(),
      amount: z.string().nullable(),
      currency: z.string().nullish(),
      shipping_amount: z.string().nullable(),
      shipping_currency: z.string().nullish(),
      customers_tracking_url: z.string().nullish(),
      customer: z.object({
        id: z.string(),
        external_id: z.string().nullish(),
        email: z.string(),
      }),
      order: z.object({
        external_id: z.string(),
        number: z.string(),
        name: z.string(),
      }),
      exchange_order: z
        .object({
          external_id: z.string().nullish(),
          number: z.string().nullish(),
          name: z.string().nullish(),
          payment_status: z.string().nullish(),
        })
        .nullish(),
      refunds: z.array(
        z.object({
          status: z.string(),
          amount: z.string(),
          currency: z.string().nullable(),
          refund_method: z.string().nullish(),
          payment_wallet: z.string().nullish(),
          requested_at: z.string().nullable(),
        }),
      ),
      return_items: z.array(
        z.object({
          id: z.string(),
          external_id: z.string(),
          transaction_type: z.string(),
          status: z.string(),
          sku: z.string(),
          price: z.string(),
          currency: z.string(),
          quantity: z.number(),
          product: z.object({
            id: z.string(),
            external_id: z.string().nullish(),
            name: z.string(),
          }),
          return_reason: z.object({
            reason: z.string(),
            reason_key: z.string(),
          }),
        }),
      ),
      delivery_option: z.object({
        name: z.string().nullish(),
        amount: z.string().nullish(),
        currency: z.string().nullish(),
        carrier_name: z.string().nullish(),
        method: z.string().nullish(),
        tracking_number: z.string().nullish(),
        tracking_url: z.string().nullish(),
        return_labels: z
          .array(
            z.object({
              carrier_status: z.string().nullish(),
              delivery_status: z.string().nullish(),
            }),
          )
          .nullish(),
        address: z
          .object({
            country: z
              .object({
                name: z.string().nullish(),
                code: z.string().nullish(),
              })
              .nullish(),
            phone: z.string().nullish(),
            first_name: z.string().nullish(),
            last_name: z.string().nullish(),
          })
          .nullish(),
      }),
      created_at: z.string(),
      updated_at: z.string(),
      expired_at: z.string().nullish(),
      cancelled_at: z.string().nullish(),
      on_hold_at: z.string().nullish(),
      pending_at: z.string().nullish(),
      shipped_at: z.string().nullish(),
      customer_shipped_at: z.string().nullish(),
      received_at: z.string().nullish(),
      for_review_at: z.string().nullish(),
      accepted_at: z.string().nullish(),
      rejected_at: z.string().nullish(),
      completed_at: z.string().nullish(),
      expires_at: z.string().nullish(),
      success_url: z.string().nullish(),
      reject_url: z.string().nullish(),
      dismiss_url: z.string().nullish(),
      summary: z.string().nullish(),
      reference: z.string().nullish(),
    }),
  ),
})

export const ReveniIntegrationResponseDataSchema = z.object({
  stores: z.array(
    z.object({
      name: z.string(),
      apiKey: z.string(),
    }),
  ),
})
